import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { LicenseV2 } from '../../models/License';

export interface LicenseState extends EntityState<LicenseV2> {
  isLoading?: boolean;
  errorMessage?: string;
}

export const licenseAdapter = createEntityAdapter<LicenseV2>({
  selectId: (i) => i.code,
});

export const licenseAdapterInitialState = licenseAdapter.getInitialState({
  isLoading: false,
});
